import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useSession } from '../contexts/SessionContext';
import { ROUTES } from '../routes/routes';

const SessionLoader = ({ children }) => {
  const { sessionId } = useParams();
  const { currentSession, loadSession, loading, error } = useSession();
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionId && (!currentSession || currentSession.sessionId !== sessionId)) {
      loadSession(sessionId);
    }
  }, [sessionId, currentSession, loadSession]);

  // If there's an error loading the session, redirect to home
  useEffect(() => {
    if (error && sessionId) {
      navigate(ROUTES.Home());
    }
  }, [error, sessionId, navigate]);

  // Show loading state while session is being loaded
  if (loading && sessionId) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px'
      }}>
        Loading your design session...
      </div>
    );
  }

  return children;
};

export default SessionLoader; 